import { useEffect, useState } from 'react'

export default function Loader({ done, onGone }) {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    if (done) {
      setProgress(100)
      const id = setTimeout(() => onGone?.(), 800)
      return () => clearTimeout(id)
    }

    let rafId = 0
    const start = performance.now()
    const duration = 1800

    const tick = (now) => {
      const ratio = Math.min((now - start) / duration, 1)
      setProgress(Math.round(ratio * 100))
      if (ratio < 1) {
        rafId = requestAnimationFrame(tick)
      }
    }

    rafId = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(rafId)
  }, [done, onGone])

  return (
    <div className={`pr-loader${done ? ' is-done' : ''}`} role="status" aria-live="polite" aria-label="Loading">
      <div className="pr-loader__panel">
        <div className="pr-loader__value" aria-live="polite">{progress}%</div>
        <div className="pr-loader__bar-wrap" aria-hidden="true">
          <div className="pr-loader__bar" style={{ width: `${progress}%` }} />
        </div>
      </div>
    </div>
  )
}
